export const LINK = {
    ROOT: '/',
    SIGNIN: '/signin',
    HOME: '/home',
    EMAIL: '/email',
    LOGOUT: '/logout'
};